import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { ProfitabilityRatiosInfo } from '../../../../../../generated/model/models';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: ProfitabilityRatiosInfo[];
  ccy?: BackportingEnums.CcyEnum;
}

const TABLE_FIELDS = [
  'grossMargin',
  'returnOnCapital',
  'returnOnTotalAssets',
  'netProfitMargin',
  'profitLossBeforeTaxNumberOfEmployees',
];

const ProfitabilityRatios: React.FC<Props> = ({ data, ccy }) => {
  return (
    <MatrixDataTable
      title={'profitabilityRatios'}
      translationsScope={'companies:companyRatios'}
      data={data}
      tableFields={TABLE_FIELDS}
      ccy={ccy}
    />
  );
};

export default ProfitabilityRatios;
